// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__1Vg1+","title":"PrivacyPolicy_title__n-4Vh","contentTitle":"PrivacyPolicy_contentTitle__MO-oU","content":"PrivacyPolicy_content__ne3zH"};